export const FETCH_DELETE_USER_BY_USER_ID_REQUEST = 'FETCH_DELETE_USER_BY_USER_ID_REQUEST'
export const FETCH_DELETE_USER_BY_USER_ID_SUCCESS = 'FETCH_DELETE_USER_BY_USER_ID_SUCCESS'
export const FETCH_DELETE_USER_BY_USER_ID_FALUIRE = 'FETCH_DELETE_USER_BY_USER_ID_FALUIRE'
